export const formatYYYYMMDD = (date: Date) => {
  return date.toLocaleDateString("sv-se").split("/").reverse().join("-");
};
